module.exports = __webpack_public_path__ + "img/PtownFlags_07.1b1c67e5.png";